module.exports = __webpack_public_path__ + "static/img/playTech.460ce50.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer/playTech.png
// module id = dk2W
// module chunks = 3